import Product from "components/shop/product";
import http from "utilities/http";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import Slider from "react-slick";

export default function Slide({ listName, productList: prod, url = '', params = { size: 12, vis_ignore: 1 } }) {
    const settingsFlashSale = {
        infinite: false,
        arrows: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    };
    const [productList, setProductList] = useState(prod || []);

    useEffect(() => {
        if (!url) return;
        const fetch = async () => {
            try {
                const result = await http(url, params);
                setProductList(result?.items || []);
            } catch (e) {
                console.log(e);
            }
        };
        fetch();
    }, []);

    useEffect(() => {
        if (isEmpty(prod)) return;
        setProductList(prod);
    }, [prod]);

    return (
        !isEmpty(productList) &&
        <div className="product-block">
            <div className="wrap">
                {
                    listName && <div className="groupCategory-title mb-0">
                        <h2 className="groupCategory-tlt">{listName}</h2>
                    </div>
                }
                <div className="flashSale display-button-slide-sp">
                    <div className="slider sliderFlashSale">
                        <Slider {...settingsFlashSale}>
                            {productList.map((item, index) => {
                                return <Product key={item.sku + index} item={item} />;
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};